import React, { useState, useEffect, useRef } from "react";
import { Button, ConfirmDialog, Dialog, InputText, Toast } from "primereact";

import AutoCompleteDropdown from "../../../../../Base/Components/Form/AutoCompleteDropdown";
import { useForm } from "../../../../../Base/Hooks/useForm";
import { toastShow } from "../../../../../Base/Services/ToastService";
import { getEstadosCategory } from "../../../../../API/Global/Status/StatusRequests";
import { addTerms, getTerms } from "../../../../../API/Compras/Terms/TermsRequest";
import { getTypesPurchaseTerms } from "../../../../../Base/API/Global/Types/TypeRequest";
import Loader from "../../../../../Base/Components/Loader/Loader";
import { InputNumber } from "primereact/inputnumber";

const TermsCrudModal = ({
  term,
  termsDialog,
  setTermsDialog,
  toastRef,
  getTerm,
  modo,
}) => {
  const toastDialog = useRef(null);
  const toast = useRef(null);

  const [show, setShow] = useState(false);

  const [estados, setEstados] = useState([{}]);
  const [termList, setTermsList] = useState([{}]);
  const [typesPurchaseTerms, setTypesPurchaseTerms] = useState([{}]);
  const [loading, setLoading] = useState(false);

  //formato de fecha
  const getFormattedDate = (isoDate) => {
    const currentDate = isoDate ? new Date(isoDate) : new Date();
    const day = ("0" + currentDate.getDate()).slice(-2);
    const month = ("0" + (currentDate.getMonth() + 1)).slice(-2);
    const year = currentDate.getFullYear().toString().slice(-2);
    let hours = currentDate.getHours();
    const meridiem = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    const minutes = ("0" + currentDate.getMinutes()).slice(-2);
    const seconds = ("0" + currentDate.getSeconds()).slice(-2);
  
    const formattedDate = `${month}/${day}/${year} ${hours}:${minutes}:${seconds} ${meridiem}`;
    return formattedDate;
  };
  
  

  const initialValues = {
    IdTerm: -1,
    Term: "",
    TermDescription: "",
    IdType: "",
    IdStatus: " ",
    DateCreate: getFormattedDate(new Date()),
    TermValue: " ",
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true)
    const estadosTempo = await getEstadosCategory("General");
    const t = await getTerms();

    const tl = await getTerms();
    setTermsList(tl);

    const types = await getTypesPurchaseTerms();
    setTypesPurchaseTerms(types);

    setTermsList(t);
    setEstados(estadosTempo);
    const estadoInicial = modo === "Crear" ? estadosTempo[0] : estadosTempo.find((e) => e.IdStatus === term?.IdStatus);

    const tipoSeleccionado = modo === "Crear" ? null : types.find((t) => t.IdType === term?.IdType);
      
    setValues({
      ...term,
      Estado: estadoInicial, // Establece el estado inicial
      IdStatus: estadoInicial.IdStatus, // Establece el IdStatus en values
      Tipos: tipoSeleccionado,
      DateCreate: modo === "Crear" ? getFormattedDate(new Date()) : getFormattedDate(term.DateCreate),
    });
    setLoading(false)
  };

  const onHide = () => {
    setTermsDialog(false);
    resetForm();
    setShow(false);
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.Term) {
      error.Term = true;
      error.error = true;
    }
    if (!values.Tipos || !values.Tipos.IdType) {
      error.IdType = true;
      error.error = true;
    }
    if (!values.Estado || !values.Estado.IdStatus) {
      error.IdStatus = true;
      error.error = true;
    }
    if (!values.TermDescription) {
      error.TermDescription = true;
      error.error = true;
    }
    // if (!/^[A-Za-z0-9ÁÉÍÓÚáéíóúÑñ\s.\-_]*$/.test(values.TermDescription)) {
    //   error.TermDescription = true;
    //   error.error = true;
    // }
    setError(error);
    return error;
  };

  const agregarTerm = async () => {
    const e = verificarInfo();
    if (!e.error) {
      const existingTerm = termList.find((pr) => pr.Term === values?.Term);
      if (
        existingTerm &&
        (modo === "Crear" || existingTerm.IdTerm !== values.IdTerm)
      ) {
        toastShow( toast, "error", "Error", "Ya existe un registro con ese nombre" );
      } else {
        let estadoId = null;
        if (values.Estado) {
          estadoId = values.Estado.IdStatus;
        }

        const a = {
          IdTerm: values?.IdTerm,
          Term: values.Term,
          TermDescription: values?.TermDescription,
          IdType: values?.Tipos.IdType,
          IdStatus: estadoId,
          DateCreate: getFormattedDate(),
          TermValue: values?.TermValue,
        };
        const resultado = await addTerms(a);
        if (modo === "Crear") {
          onHide();
          toastShow(toastRef, "success", "Datos Agregados", "Termino Agregado exitosamente.");
          getTerm();
        } else {
          onHide();
          toastShow(toastRef, "success", "Datos Agregados", "Termino modificado exitosamente.");
          getTerm();
        }
      }
    }
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={modo === "Crear" ? "Guardar" : "Modificar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => { agregarTerm()}}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (termsDialog) {
      getValoresIniciales();
    }
  }, [termsDialog]);

  const dialogTitle = modo === "Crear" ? "Agregar Término" : "Modificar Término";

  return (
    <div>
      <Dialog
        visible={termsDialog}
        modal
        className="modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
      >
        <div id="Dialog">
        <Loader loading={loading} querySelector={"#Dialog"} />
        <div style={{ width: "100", margin: "auto" }}>
          <div className="d-flex align-items-center">
            <h2 className="me-3">{dialogTitle}</h2>
          </div>
          <Toast ref={toastDialog} style={{ zIndex: 50000 }} />

          <div className="modal__input-contenedor">
            <div className="field col-6 me-2">
              <span className="p-float-label">
                <InputText
                  name="Term"
                  value={values.Term}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                  className={error.Term ? "p-invalid" : ""}
                />
                <label htmlFor="NombreEstante">Nombre del Termino</label>
              </span>
            </div>

            <div className="field col-6 me-2">
              <span className="p-float-label">
                <InputText
                  name="TermDescription"
                  value={values.TermDescription}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                  className={error.TermDescription ? "p-invalid" : ""}
                />
                <label htmlFor="TermDescription">Descripción</label>
                {error.TermDescription && (
                  <small className="p-error">
                     La Descripción solo puede contener letras, números, espacios y los caracteres '.', '_', '-'.
                  </small>
                )}

              </span>
            </div>
          </div>

          <div className="modal__input-contenedor">
            <div className="field col-6 me-2">
              <span className="p-float-label">
                <AutoCompleteDropdown
                  name={"Tipos"}
                  value={values.Tipos}
                  items={typesPurchaseTerms}
                  field={"Type"}
                  label={"Tipo"}
                  handleInputChange={handleInputChange}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                  className={error.IdType ? "p-invalid" : ""}
                />
              </span>
            </div>

            <div className="field col-6 me-2">
              <span className="p-float-label">
                <AutoCompleteDropdown
                  name={"Estado"}
                  value={values.Estado}
                  items={estados}
                  field={"StatusName"}
                  label={"Estado"}
                  handleInputChange={handleInputChange}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                  className={error.IdStatus ? "p-invalid" : ""}
                />
              </span>
            </div>
          </div>

          <div className="modal__input-contenedor">
          <div className="field col-6 me-2">
              <span className="p-float-label">
              <InputNumber
                  name="TermValue"
                  value={values.TermValue}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  autoComplete="off"
                  label={"Fecha"}
                  className={error.TermValue ? "p-invalid" : ""}
                />
                <label htmlFor="TermValue">TermValue</label>
              </span>
            </div>
            <div className="field col-6 me-2">
              <span className="p-float-label">
                <InputText
                  name="DateCreate"
                  value={values.DateCreate}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  autoComplete="off"
                  readOnly
                  label={"Fecha"}
                />
                <label htmlFor="DateCreate">Fecha de Creación</label>
              </span>
            </div>
          </div>
        </div>
        </div>
      </Dialog>
    </div>
  );
};

export default TermsCrudModal;
